module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/BW/basketball-d9d947ddac534800eb65a0e3664bf81c.svg";